// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: inline-flex;
    vertical-align: middle;
    margin-left: 4px;
}

:host(.hidden) { display: none; }

.hi-btn {
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: var(--bg-secondary, #e0e0e0);
    color: var(--text-secondary, #666);
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    cursor: default;
}

.hi-btn.hi-clickable {
    cursor: pointer;
}

.hi-btn.hi-clickable:hover {
    background: var(--accent-color, #0066cc);
    color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/help-icon.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,iBAAiB,aAAa,EAAE;;AAEhC;IACI,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf","sourcesContent":[":host {\n    display: inline-flex;\n    vertical-align: middle;\n    margin-left: 4px;\n}\n\n:host(.hidden) { display: none; }\n\n.hi-btn {\n    all: unset;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    background: var(--bg-secondary, #e0e0e0);\n    color: var(--text-secondary, #666);\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 1;\n    cursor: default;\n}\n\n.hi-btn.hi-clickable {\n    cursor: pointer;\n}\n\n.hi-btn.hi-clickable:hover {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
